import * as React from "react";
import axios from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";


import { toast } from "react-toastify";
import { useState } from "react";
import { useEffect } from "react";

const VendorSubcriptionPlan = () => {
  const [data, setData] = useState([]);

  const vendorSubscriptionList = () => {
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/vendor-subscription-plan-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
        toast.error(error.message);
      });
  };

  useEffect(() => {
    vendorSubscriptionList();
  }, []);

  // const approvadData = (ids) => {
  //   const fd = new FormData();
  //   fd.append("product_id", ids);
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/api/multivendor-approve-pending-product/`,
  //       fd,
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       toast.success(response?.data?.message);
  //       vendorSubscriptionList();
  //     })
  //     .catch((error) => {
  //       console.log("", error.response);
  //       console.log(error);
  //       toast.error(error.message);
  //     });
  // }

  return (
    <>
      <div className="!bg-white">
        <div className="flex justify-between !bg-slate-100">
          <div className="p-2">
            <p className="text-xl font-bold !text-black">
              Vendor Subcription Plan Management List
            </p>
            <p className="!text-black">View/Search Vendor Subcription Plan Management List </p>
          </div>
          <div className="p-2 pt-5  ">
            <div className="flex items-center p-2 h-14 !bg-slate-100 border-zinc-600">
              {/* <input
                type="text"
                className="!border-3 !border-black px-2 !w-64 rounded-md py-1"
                placeholder="search"
                style={{ border: "1px solid black" }}
              /> */}
            </div>
          </div>
        </div>
        <div className="">
          <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-10"> Id</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-36">Subscription Name </div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    DESCRIPTION
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center  !text-gray-800 !font-bold"
                  >
                    <div className="w-48">COMMISSION PERCENTAGE</div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map((row) => (
                    <TableRow
                      key={row?.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.id ? row?.id : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.subscription_name
                          ? row?.subscription_name
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #D0D0D0",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.description
                          ? row?.description
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.commission_percentage ? row?.commission_percentage : "--"}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorSubcriptionPlan;
